import { useTranslation } from "react-i18next";

export default function WhatIs() {
  const { t } = useTranslation();

  return (
    <section id="what-is" className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6">
              {t("home.whatIs.title")}
            </h2>
            <p className="text-gray-600 leading-relaxed mb-6 text-base">
              {t("home.whatIs.content")}
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-6 py-3 bg-emerald-700 text-white font-medium rounded-lg hover:bg-emerald-800 transition-colors"
            >
              {t("home.whatIs.cta")}
              <i className="ri-arrow-right-line" />
            </a>
          </div>
          <div className="relative rounded-2xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=An%20organized%20digital%20shopping%20workspace%20scene%20with%20a%20laptop%20showing%20a%20product%20spreadsheet%20surrounded%20by%20physical%20fashion%20items%20like%20folded%20clothes%20and%20sneakers%20on%20a%20white%20desk%2C%20clean%20bright%20workspace%2C%20soft%20daylight%2C%20modern%20minimal%20productivity%20aesthetic%2C%20top%20down%20slight%20angle%2C%20fresh%20organized%20feel&width=800&height=600&seq=whatis-img&orientation=landscape&nocache=true"
              alt="CSSBuy Spreadsheet Products"
              className="w-full h-64 md:h-80 object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}